module.exports = __webpack_public_path__ + "assets/img/font8.f144ad42.png";